exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2iD4MFIn1lOJMddbLNz2DC{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;overflow:hidden}", ""]);
// Exports
exports.locals = {
	"compactRecipientRow": "_2iD4MFIn1lOJMddbLNz2DC"
};